import * as actionTypes from './actionTypes'

export const startRequest = () => {
  return {
    type: actionTypes.START_REQUEST
  }
}

export const finishRequest = () => {
  return {
    type: actionTypes.FINISH_REQUEST
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/Loading.js